import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {BpmnModelerService} from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';
import {
  ClearNodeSelection,
  NodeActionTypes
} from "@ispm-client/modules/bpmn-modeler/store/actions";

@Injectable()
export class SelectionNodeEffect {
  constructor(private actions$: Actions,
              private bpmnModelerService: BpmnModelerService) {
  }

  @Effect({dispatch: false})
  clearNodeSelectionEffect$: Observable<Action> = this.actions$
    .pipe(
      ofType<ClearNodeSelection>(NodeActionTypes.CLEAR_NODE_SELECTION),
      tap((action: ClearNodeSelection) => {
        return this.bpmnModelerService.clearNodeSelection();
      })
    );
}
